// extracted by mini-css-extract-plugin
module.exports = {"cookiesFooter":"CookiesFooter_cookiesFooter__lDDZ_","centerCookiesFooter":"CookiesFooter_centerCookiesFooter__u_hEd","button":"CookiesFooter_button__cxyaG"};